import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(partnerId, queue) {
  return yield oncallFetch(
    "/api/oncall/administration/partners/queues/remove",
    { partnerId, queue },
  );
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/partners/queues/remove.js